module.exports = __webpack_public_path__ + "img/l-cb9-21-op.ecc1b2fe.png";